import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeviceListComponent } from './pages/device-list/device-list.component';
import { DeviceUpgradeComponent } from './pages/device-upgrade/device-upgrade.component';
import { FirmwareListComponent } from './pages/firmware-list/firmware-list.component';
import { DeviceRoutes } from './device.routes';
import { firmwareAdministrationGuard } from '@guards/firmware-administration.guard';

const ROUTES: Routes = [
    { path: DeviceRoutes.DeviceList, component: DeviceListComponent },
    { path: DeviceRoutes.DeviceUpgrade, component: DeviceUpgradeComponent },
    {
        path: DeviceRoutes.FirmwareList,
        component: FirmwareListComponent,
        canActivate: [firmwareAdministrationGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class DeviceRoutingModule {}
